/*
  Ratings_v2.js propTypes
  extracted from https://bully---varnish.ref-sa-tech.io/documentation/resources/oaspec.json
  on 2019-04-15T15:32:06.065Z
*/

import { string } from 'prop-types'

export const ReviewCustomer_v1 = {
  author: string,
  customerNumber: string,
  firstName: string,
  lastName: string,
}
